export const UiMessageType = {
    none: '',
    success: 'Sucess',
    warning: 'Warning',
    error: 'error'
  }


  export class UiMessage {
    message: string;
    messageType: typeof UiMessageType.none;
    received: Date;
    clearForm?: boolean;

    constructor(
        message: string,
        messageType: typeof UiMessageType.none,
        clearForm?:boolean
    ) {
        this.message = message;
        this.messageType = messageType;
        this.received = new Date();
        this.clearForm = clearForm;
    }

    static empty(): UiMessage {
        return { message: '', messageType: UiMessageType.none, received: new Date()};
    }
}